import { OrganizationDto } from "@intelligems/ig-types/dtos/organizations";
import { shortId } from "@intelligems/ig-utils/common";
import { createSlice } from "@reduxjs/toolkit";
import { IOrganizationState } from "@src/store/slices/organization/types";

const initialState: IOrganizationState = {};

const slice = createSlice({
  name: "organization",
  initialState,
  reducers: (create) => ({
    initOrganization: create.reducer<OrganizationDto>((state, action) => {
      state.organization = action.payload;
    }),
  }),
  selectors: {
    getOrganization: (state) => state.organization,
    getShortOrgId: (state) =>
      state.organization?.id ? shortId(state.organization.id) : "",
  },
});

export const { initOrganization } = slice.actions;
export const { getOrganization, getShortOrgId } = slice.selectors;

export const organizationReducer = slice.reducer;
